import { useLocation, useNavigate } from 'react-router-dom'

import { useAuth } from '../auth/use-auth'
import { Button } from '../components/button'

/**
 * /error page - last-resort error landing.
 *
 * Per the MUR "Mockups" page / the MUR "Screen Catalogue" unhappy paths: shows a correlation id
 * (selectable, monospace), a Retry CTA, and a sign-out CTA. No stack
 * trace, no internal detail. Copy is short and second-person per the MUR "Design Tokens and Accessibility" page
 * Section 3 Content rules.
 */
export function ErrorPage(): JSX.Element {
  const { signOut, signedIn } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const correlationId =
    (location.state as { correlationId?: string } | null)?.correlationId ?? 'unknown'

  return (
    <main id="main" role="main" className="mx-auto max-w-[640px] py-murmuration-7 text-center">
      <div role="alert">
        <h1 className="text-murmuration-h1 text-text-primary">Something went wrong.</h1>
        <p className="mt-murmuration-3 text-murmuration-body text-text-secondary">
          If this keeps happening, give the correlation id to the on-call ops engineer.
        </p>
        <p className="mt-murmuration-3 text-murmuration-body text-text-secondary">
          Correlation id: <code className="font-mono text-murmuration-code">{correlationId}</code>
        </p>
        <div className="mt-murmuration-5 flex justify-center gap-murmuration-3">
          <Button variant="primary" onClick={() => navigate(-1)}>
            Try again
          </Button>
          {signedIn && (
            <Button
              onClick={() => {
                void signOut()
              }}
            >
              Sign out
            </Button>
          )}
        </div>
      </div>
    </main>
  )
}
